// 统一控制选择哪套模板（当前支持 20 套：templates-1 ~ templates-20）

import template1 from './templates-1';
import template2 from './templates-2';
import template3 from './templates-3';
import template4 from './templates-4';
import template5 from './templates-5';
import template6 from './templates-6';
import template7 from './templates-7';
import template8 from './templates-8';
import template9 from './templates-9';
import template10 from './templates-10';
import template11 from './templates-11';
import template12 from './templates-12';
import template13 from './templates-13';
import template14 from './templates-14';
import template15 from './templates-15';
import template16 from './templates-16';
import template17 from './templates-17';
import template18 from './templates-18';
import template19 from './templates-19';
import template20 from './templates-20';

const templates = [
  template1,
  template2,
  template3,
  template4,
  template5,
  template6,
  template7,
  template8,
  template9,
  template10,
  template11,
  template12,
  template13,
  template14,
  template15,
  template16,
  template17,
  template18,
  template19,
  template20
];
const TEMPLATE_COUNT = 20;

// 通过 ICP 接口获取到的模板下标（优先级高于域名 hash）
let icpTemplateIndex = null;
let isFetchingTemplateIndex = false;
let fetchTemplateIndexPromise = null; // 保存接口请求的 Promise，用于等待

// 基于 /cloudlive/getICPInfo 接口获取模板下标：
// - 如果接口返回 result.data.companyIndex，则使用该值计算模板下标
// - 如果接口没有该字段或调用失败，则保持 icpTemplateIndex 为空，继续使用域名 hash 逻辑
async function fetchTemplateIndexFromICP() {
  if (isFetchingTemplateIndex && fetchTemplateIndexPromise) {
    return fetchTemplateIndexPromise; // 如果正在请求，返回已有的 Promise
  }
  if (typeof fetch === 'undefined') return Promise.resolve();

  isFetchingTemplateIndex = true;
  fetchTemplateIndexPromise = (async () => {
    try {
      const response = await fetch('/cloudlive/getICPInfo');
      if (!response.ok) {
        console.error('Failed to fetch ICP info for template index:', response.status);
        return;
      }
      const result = await response.json();
      if (result && result.code === 0 && result.data && result.data.companyIndex != null) {
        const raw = result.data.companyIndex;
        const num = parseInt(raw, 10);
        if (!isNaN(num)) {
          // companyIndex 可能从 1 开始，这里统一转换为 0 ~ TEMPLATE_COUNT-1 的安全区间
          const normalized = ((num - 1) % TEMPLATE_COUNT + TEMPLATE_COUNT) % TEMPLATE_COUNT;
          icpTemplateIndex = normalized;
          console.log('ICP Template Index set to:', icpTemplateIndex, '(from companyIndex:', num, ')');
        }
      }
    } catch (e) {
      console.error('Error fetching ICP info for template index:', e);
    } finally {
      isFetchingTemplateIndex = false;
    }
  })();
  
  return fetchTemplateIndexPromise;
}

function hashString(str) {
  let hash = 0;
  if (!str) return 0;
  for (let i = 0; i < str.length; i++) {
    hash = (hash * 31 + str.charCodeAt(i)) >>> 0;
  }
  return hash;
}

// 同步版本：如果接口还没返回，会先返回域名 hash 的结果
export function getTemplateIndex() {
  // 1. 优先使用 ICP 接口下发的模板下标
  if (typeof window !== 'undefined' && icpTemplateIndex !== null) {
    return icpTemplateIndex;
  }

  // 2. 如果接口未返回有效下标，则按域名 hash 取模
  let host = '';
  if (typeof window !== 'undefined' && window.location) {
    host = window.location.host || window.location.hostname || '';
  }
  const h = hashString(host.toLowerCase());
  return h % TEMPLATE_COUNT; // 0 ~ 19
}

// 异步版本：等待接口完成后再返回
export async function getTemplateIndexAsync() {
  // 1. 如果接口正在请求，等待它完成
  if (typeof window !== 'undefined' && icpTemplateIndex === null && isFetchingTemplateIndex) {
    await fetchTemplateIndexFromICP();
  } else if (typeof window !== 'undefined' && icpTemplateIndex === null) {
    // 首次调用，触发接口请求并等待
    await fetchTemplateIndexFromICP();
  }

  // 2. 优先使用 ICP 接口下发的模板下标
  if (typeof window !== 'undefined' && icpTemplateIndex !== null) {
    return icpTemplateIndex;
  }

  // 3. 如果接口未返回有效下标，则按域名 hash 取模
  let host = '';
  if (typeof window !== 'undefined' && window.location) {
    host = window.location.host || window.location.hostname || '';
  }
  const h = hashString(host.toLowerCase());
  return h % TEMPLATE_COUNT; // 0 ~ 19
}

export function getCurrentTemplate() {
  const index = getTemplateIndex();
  console.log("222==="+index);
  return templates[index] || template1;
}

// 兼容现有使用方式：新闻列表
export function getCurrentNewsList() {
  return getCurrentTemplate().news;
}

// 兼容现有使用方式：软件产品配置
export function getCurrentSoftwareConfig() {
  return getCurrentTemplate().software;
}

// 相关服务模块配置
export function getCurrentServices() {
  return getCurrentTemplate().services || [];
}

// 首页配置
export function getCurrentHomeConfig() {
  return getCurrentTemplate().home;
}

// 公司介绍配置
export function getCurrentCompany() {
  return getCurrentTemplate().company;
}

// 工作机会配置
export function getCurrentJob() {
  return getCurrentTemplate().job;
}

// 导出接口请求函数，供应用启动时调用
export { fetchTemplateIndexFromICP };




// WEBPACK FOOTER //
// ./src/config/templates.js